import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-textcounter', 'remaining', 'simbolių');
Labels.set(
    'ui-textcounter',
    'invalid',
    'Prašome naudoti ne daugiau kaip %d simbolių.'
);
